import { AnyAction, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { loadingBarMiddleware } from "react-redux-loading-bar";

import rootReducer from "../reducers/shared-reducers";
import errorMiddleware from "../middlewares/error-middleware";
import notificationMiddleware from "../middlewares/notification-middleware";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "REGISTER",
          "payload.config",
          "payload.request",
          "payload.headers",
          "error",
          "meta.arg",
        ],
      },
    }).concat(
      errorMiddleware,
      notificationMiddleware,
      loadingBarMiddleware()
    ),
});

export const getStore = () => store;

export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const persistor = persistStore(store);
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  IRootState,
  unknown,
  AnyAction
>;

// export const getStore;
